'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _otherUtils = require('../other/utils');

var _otherUtils2 = _interopRequireDefault(_otherUtils);

exports['default'] = formlyUtil;

// @ngInject
function formlyUtil() {
  return _otherUtils2['default'];
}
module.exports = exports['default'];


/** WEBPACK FOOTER **
 ** ./services/formlyUtil.js
 **/